import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from "../../shared";
import { Observable } from 'rxjs';
import { CfMessageDfnContainerModel } from "../../../../../../models/aggregates/alg/bot";

@Injectable({providedIn: "root"})
export class CfMessageDfnService extends BaseApiTemplateService<CfMessageDfnContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_BOT_MODULE + 'cf-message-dfn';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_BOT_MODULE + 'cf-message-dfn';
    this.httpClient = http;
  }

  search(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<CfMessageDfnContainerModel>> {
    let url = this.apiUrl + '/search';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/search' + '?' + pagination.getQueryKeyValues();;
    }
    return this.httpClient.get<PagingResponseModel<CfMessageDfnContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

}
